import React from "react";
import brand from "../content/brand";

const Metrics = () => (
  <section className="metrics">
    <div className="shell">
      <div className="row">
        {brand.metrics.map((m) => (
          <div key={m.label} className="cell">
            <div className="v">{m.value}</div>
            <div className="l">{m.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Metrics;
